/**
 * Canonical wildcard-aware permission check.
 *
 * Supported grant forms:
 *   '*'           — global wildcard (all permissions)
 *   'domain.*'    — domain wildcard (all permissions in a domain)
 *   '*.action'    — action wildcard (a specific action across all domains)
 *   'domain.action' — exact match
 */
export function hasPermission(granted: Set<string>, required: string): boolean {
  if (granted.has('*')) return true
  if (granted.has(required)) return true
  const parts = required.split('.')
  if (granted.has(parts[0] + '.*')) return true
  const action = parts.slice(1).join('.')
  if (action && granted.has('*.' + action)) return true
  return false
}
